<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import eventBus from '@/utils/event.js';
export default {
  name: 'app',
  data() {
    return {
      electron: this.$route.query.electron,
      typeHash: sessionStorage.getItem('hash') || this.$route.hash,
    };
  },
  methods: {
    loadScript(url) {
      const myScript = document.createElement('script');
      myScript.src = url;
      myScript.type = 'text/javascript';
      document.head.appendChild(myScript);
      return new Promise((resolve) => {
        myScript.onload = resolve;
      });
    },
    setFavIconNTitle(hash) {
      console.log(hash,'hashzrjzrjzrj');
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${process.env.BASE_URL}favicon.ico`;
      if (hash === '#normal') {
        link.href = `${process.env.BASE_URL}codepku-favicon.ico`;
      }
      document.getElementsByTagName('head')[0].appendChild(link);
      document.title = hash === ('#normal') ? '编玩边学在线考试平台' : '蓝桥杯考试系统';
    },
  },

  created() {
      this.setFavIconNTitle(this.typeHash);
  },
  mounted() {
    if (this.electron) {
      // this.loadScript('./src/renderer.js');
    }
    setTimeout(() => {
      this.setFavIconNTitle(this.typeHash);
    },100);
  },
  watch: {
    '$route.hash': {
      handler(val) {
        console.log(val,'valvalvalval');
        if (val) {
          this.typeHash = val;
          sessionStorage.setItem('hash', this.typeHash);
          this.setFavIconNTitle(val);
          eventBus.$emit('normalLogin',true);
        }
      },
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>
